// Applies admin-configured brand colors to the CSS variables at runtime.
export const THEME_DEFAULTS = {
  primary_color: "#D97757",
  secondary_color: "#2D5A4C",
  accent_color: "#E0A63C",
};

// Dark mode ------------------------------------------------------------
const DARK_KEY = "yalola.dark";

export const initDarkMode = () => {
  if (localStorage.getItem(DARK_KEY) === "1") document.documentElement.classList.add("dark");
};

export const isDarkMode = () => document.documentElement.classList.contains("dark");

export const toggleDarkMode = () => {
  const on = document.documentElement.classList.toggle("dark");
  localStorage.setItem(DARK_KEY, on ? "1" : "0");
  return on;
};

export const applyTheme = (brand) => {
  if (!brand) return;
  const r = document.documentElement.style;
  const set = (k, v) => { if (v) r.setProperty(k, v); else r.removeProperty(k); };
  // Couleur = défaut → on laisse la feuille de style décider (le mode sombre éclaircit la sauge, etc.) ;
  // un style inline sur <html> écraserait sinon les règles `.dark`.
  const custom = (k) => (brand[k] && brand[k].toLowerCase() !== THEME_DEFAULTS[k].toLowerCase() ? brand[k] : null);
  const primary = custom("primary_color"), secondary = custom("secondary_color"), accent = custom("accent_color");
  set("--yalola-primary", primary);
  set("--yalola-primary-hover", primary);
  set("--yalola-primary-soft", primary ? primary + "1f" : null);
  set("--yalola-secondary", secondary);
  set("--yalola-secondary-hover", secondary);
  set("--yalola-secondary-soft", secondary ? secondary + "1a" : null);
  set("--yalola-accent", accent);
  set("--yalola-accent-soft", accent ? accent + "26" : null);
  set("--gradient-coral", primary ? `linear-gradient(135deg, ${primary}E6 0%, ${primary} 100%)` : null);
  set("--gradient-navy", secondary ? `linear-gradient(135deg, ${secondary}E6 0%, ${secondary} 100%)` : null);
  applyFavicon(brand.favicon_url);
};

const DEFAULT_FAVICON = "/favicon.png";
// Bump to force browsers to drop a previously-cached (black-cornered) favicon.
const FAVICON_VERSION = "3";

export const applyFavicon = (url) => {
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  let resolved = url
    ? (url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url)
    : DEFAULT_FAVICON;
  // A .jpg/.jpeg has no alpha channel → transparent corners render BLACK. Never
  // use one as the favicon; always fall back to the transparent PNG, whatever
  // the DB / brand config holds (protects production from a stale .jpg value).
  if (/\.jpe?g(\?|#|$)/i.test(resolved)) resolved = DEFAULT_FAVICON;
  const busted = resolved.includes("?") ? `${resolved}&v=${FAVICON_VERSION}` : `${resolved}?v=${FAVICON_VERSION}`;
  link.type = "image/png";
  if (!link.href.endsWith(busted)) link.href = busted;
};

export const applyPwaMeta = (settings) => {
  if (!settings) return;
  const pwa = settings.pwa || {};
  const theme = pwa.theme_color || settings.brand?.primary_color;
  if (theme) {
    let m = document.querySelector("meta[name='theme-color']");
    if (!m) { m = document.createElement("meta"); m.name = "theme-color"; document.head.appendChild(m); }
    m.content = theme;
  }
  const title = pwa.short_name || settings.app_name;
  if (title) {
    let m = document.querySelector("meta[name='apple-mobile-web-app-title']");
    if (!m) { m = document.createElement("meta"); m.name = "apple-mobile-web-app-title"; document.head.appendChild(m); }
    m.content = title;
  }
  if (pwa.icon_url) {
    let link = document.querySelector("link[rel='apple-touch-icon']");
    if (!link) { link = document.createElement("link"); link.rel = "apple-touch-icon"; document.head.appendChild(link); }
    link.href = pwa.icon_url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${pwa.icon_url}` : pwa.icon_url;
  }
};
